/**
 * Options for encoding CMCD values.
 *
 * @group CMSD
 *
 * @beta
 */
export type CmsdEncodeOptions = {
	/**
	 * Use Symbol to represent token values
	 *
	 * @defaultValue `true`
	 */
	useSymbol?: boolean;
};
